module.exports = __webpack_public_path__ + "img/editIcon.d8712d64.svg";